import Vue from 'vue'
import Router from 'vue-router'
//首页
import Index from "../pages/index"
//关于我们
import About from "../pages/about"
//服务
import Server from "../pages/server"
//耳机列表页
import EarphoneList from "../pages/earphoneList"
// 影音产品列表页
import AudioList from "../pages/audioList"
//媒体新闻
import Media from "../pages/media"
// 蓝牙耳机
import EarphoneListBlue from "../pages/earphoneList_blue"
//产品详情页 - a8
import ProductA8 from "../pages/products/a8"
//产品详情页 - c5
import ProductC5 from "../pages/products/c5"
//产品详情页 - f1
import ProductF1 from "../pages/products/f1"
//产品详情页 - f3
import ProductF3 from "../pages/products/f3"
//产品详情页 - a7
import ProductA7 from "../pages/products/a7"
//产品详情页 - f0
import ProductF0 from "../pages/products/f0"
//产品详情页 - T0
import ProductT0 from "../pages/products/t0"
//产品详情页 - s1
import ProductS1 from "../pages/products/s1"
//产品详情页 - f4
import ProductF4 from "../pages/products/f4"
//产品详情页 - f5
import ProductF5 from "../pages/products/f5"
//产品详情页 - t2
import ProductT2 from "../pages/products/t2"
//产品详情页 - t3
import ProductT3 from "../pages/products/t3"
//产品详情页 - b0
import ProductB0 from "../pages/products/b0"
//产品详情页 - s0
import ProductS0 from "../pages/products/s0"
//产品详情页 - i5
import ProductI5 from "../pages/products/i5"
//产品详情页 - A12
import ProductA12 from "../pages/products/a12"
//产品详情页 - A9
import ProductA9 from "../pages/products/a9"
// 产品详情页 - G6
import ProductG6 from "../pages/products/g6"
// 产品详情页 - N1
import ProductN1 from "../pages/products/N/n1.vue"
// 产品详情页 - N5
import ProductN5 from "../pages/products/N/n5.vue"
// 产品详情页 - F10
import ProductF10 from "../pages/products/F/f10.vue"
// 产品详情页 - F50
import ProductF50 from "../pages/products/F/f50.vue"
// 产品详情页 - T1
import ProductT1 from "../pages/products/T/t1.vue"
// 产品详情页 - T5
import ProductT5 from "../pages/products/T/t5.vue"
// 产品详情页 - S10
import ProductS10 from "../pages/products/S/s10.vue"
// 产品详情页 - F30
import ProductF30 from "../pages/products/F/f30.vue"
// 产品详情页 - F20
import ProductF20 from "../pages/products/F/f20.vue"
// 产品详情页 - A1
import ProductA1 from "../pages/products/A/a1.vue"
// 产品详情页 - A3
import ProductA3 from "../pages/products/A/a3.vue"
// 产品详情页 - A10
import ProductA10 from "../pages/products/A/a10.vue"
// 产品详情页 - W1
import ProductW1 from "../pages/products/W/w1.vue"
// 产品详情页 - W3
import ProductW3 from "../pages/products/W/w3.vue"
// 产品详情页 - W0
import ProductW0 from "../pages/products/W/w0.vue"
// 产品详情页 - W5
import ProductW5 from "../pages/products/W/w5.vue"
// 产品详情页 - W8
import ProductW8 from "../pages/products/W/w8.vue"
// 产品详情页 - W9
import ProductW9 from "../pages/products/W/w9.vue"
// 产品详情页 - X3
import ProductX3 from "../pages/products/X/x3.vue"
// 产品详情页 - H2
import ProductH2 from "../pages/products/H/h2.vue"
// 产品详情页 - H5
import ProductH5 from "../pages/products/H/h5.vue"
// 产品详情页 - W11
import ProductW11 from "../pages/products/W/w11.vue"
// 产品详情页 - W10
import ProductW10 from "../pages/products/W/w10.vue"

// 英文站点
import English from "../pages/english/index2"

Vue.use(Router)

/**
 * 判断浏览器语言 中英文
 */
let getLang = () => {
  var language = (navigator.language || navigator.browserLanguage).toLowerCase();
  if(language.indexOf('en')>-1){
      // 英文
      return English;
  }else {
      // 中文
      return Index;
  }
}

export default new Router({
  mode : "history",
  scrollBehavior: () => ({ y: 0}),  // 切换路由时，滚动到顶部
  routes: [
    {
      path: '/',
      component: getLang()
    },{
      path: '/about/:anchor',
      component: About
    },{
      path: "/server/:anchor",
      component: Server
    },{
      path: "/security.html",
      redirect: '/server/security',
      component: Server
    },{
      path: "/earphoneList",
      component: EarphoneList
    },{
      path: "/earphoneListBlue",
      component: EarphoneListBlue
    },{
      path: "/audioList",
      component: AudioList
    },{
      path: "/media",
      component: Media
    },{
      path: "/product/a8",
      component: ProductA8
    // },{
    //   path: "/product/c5",
    //   component: ProductC5
    // },{
    //   path: "/product/f1",
    //   component: ProductF1
    // },{
    //   path: "/product/f3",
    //   component: ProductF3
    // },{
    //   path: "/product/a7",
    //   component: ProductA7
    // },{
    //   path: "/product/f0",
    //   component: ProductF0
    },{
      path: "/product/t0",
      component: ProductT0
    // },{
    //   path: "/product/s1",
    //   component: ProductS1
    // },{
    //   path: "/product/f4",
    //   component: ProductF4
    // },{
    //   path: "/product/f5",
    //   component: ProductF5
    // },{
    //   path: "/product/t2",
    //   component: ProductT2
    // },{
    //   path: "/product/t3",
    //   component: ProductT3
    // },{
    //   path: "/product/b0",
    //   component: ProductB0
    // },{
    //   path: "/product/s0",
    //   component: ProductS0
    // },{
    //   path: "/product/i5",
    //   component: ProductI5
    // },{
    //   path: "/product/a12",
    //   component: ProductA12
    // },{
    //   path: "/product/a9",
    //   component: ProductA9
    // },{
    //   path: "/product/G6",
    //   component: ProductG6
    // },{
    //   path: '/product/n1',
    //   component: ProductN1
    // },{
    //   path: '/product/n5',
    //   component: ProductN5
    // },{
    //   path: '/product/f10',
    //   component: ProductF10
    // },{
    //   path: '/product/f50',
    //   component: ProductF50
    // },{
    //   path: '/product/t1',
    //   component: ProductT1
    },{
      path: '/product/t5',
      component: ProductT5
    // },{
    //   path: '/product/s10',
    //   component: ProductS10
    // },{
    //   path: '/product/f30',
    //   component: ProductF30
    // },{
    //   path: '/product/f20',
    //   component: ProductF20
    // },{
    //   path: '/product/a1',
    //   component: ProductA1
    // },{
    //   path: '/product/a3',
    //   component: ProductA3
    // },{
    //   path: '/product/a10',
    //   component: ProductA10
    // },{
    //   path: '/product/w1',
    //   component: ProductW1
    // },{
    //   path: '/product/w3',
    //   component: ProductW3
    },{
      path: '/product/w0',
      component: ProductW0
    // },{
    //   path: '/product/w5',
    //   component: ProductW5
    // },{
    //   path: '/product/w8',
    //   component: ProductW8
    },{
      path: '/product/w9',
      component: ProductW9
    },{
      path: '/product/x3',
      component: ProductX3
    },{
      path: '/product/h2',
      component: ProductH2
    },{
      path: '/product/h5',
      component: ProductH5
    },{
      path: '/product/w11',
      component: ProductW11
    },{
      path: '/product/w10',
      component: ProductW10
    },{
      path: "/en",
      component: English
    // },{
    //   path: "*",
    //   redirect: '/server/security',
    //   component: Server
    }, {
      path: "*", // 此处需特别注意置于最底部
      redirect: "/"
      }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js